import { z } from 'zod';
import type { IncomingTransferUpsertedEventPayload } from './incoming-transfers-sync.dto.js';
import { ShipmentStatusSchema } from '../../shipments/shipments-types.js';
import { CounterpartySnapshotSchema } from '../../counterparties/counterparties.schema.js';
import { IsoDateTimeSchema } from '../../shipments/shipments-types.js';
import { IncomingTransferReceiptStatusSchema } from '../../inbound-receipts/inbound-receipts-types.js';

const IncomingTransferSyncPayloadBaseSchema = z
  .object({
    schemaVersion: z.literal(1),
    eventId: z.uuid(),
    occurredAt: IsoDateTimeSchema,
    companyId: z.uuid(),
    stationId: z.uuid(),
    sourceShipmentId: z.uuid(),
  })
  .strict();

export const IncomingTransferUpsertedEventPayloadSchema: z.ZodType<IncomingTransferUpsertedEventPayload> =
  IncomingTransferSyncPayloadBaseSchema.extend({
    sourceShipmentCompanyId: z.uuid(),
    materialId: z.uuid(),
    sourceShipmentStatus: ShipmentStatusSchema,
    receiptStatus: IncomingTransferReceiptStatusSchema,
    confirmedReceiptId: z.uuid().nullable(),
    shipper: CounterpartySnapshotSchema,
    receiver: CounterpartySnapshotSchema,
    transferReference: z.string().trim().min(1).nullable(),
    reportRangeStartAt: IsoDateTimeSchema.nullable(),
    reportRangeEndAt: IsoDateTimeSchema.nullable(),
    shippedRedemptionWeightLb: z.number().min(0).nullable(),
    shippedRefundValueCents: z.int().min(0).nullable(),
    totalWeightLb: z.number().min(0).nullable(),
    createdAt: IsoDateTimeSchema,
    departedAt: IsoDateTimeSchema.nullable(),
    receiptConfirmedAt: IsoDateTimeSchema.nullable(),
    receiptCanceledAt: IsoDateTimeSchema.nullable(),
  }).strict();
